export const SET_REFERRAL_BANK_DETAILS = 'SET_REFERRAL_BANK_DETAILS';
export const LOAD_REFERRAL_BANK_DETAILS = 'LOAD_REFERRAL_BANK_DETAILS';
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const SET_BANK_DETAILS_NEW = 'SET_BANK_DETAILS_NEW';
export const SET_FILE_UPLOAD_DIRTY = 'SET_FILE_UPLOAD_DIRTY';

export const loadReferralBankDetails = () => ({
  type: LOAD_REFERRAL_BANK_DETAILS
});

export const setReferralBankDetails = payload => ({
  type: SET_REFERRAL_BANK_DETAILS,
  payload
});

export const setFormState = formState => ({
  type: SET_FORM_STATE,
  formState
});

export const setBankDetailsNew = () => ({
  type: SET_BANK_DETAILS_NEW
});

export const setFileUploadDirty = fileUploadDirty => ({
  type: SET_FILE_UPLOAD_DIRTY,
  fileUploadDirty
});

const initialState = {
  editing: false,
  loading: true,
  referralBankDetails: {
    iso: '',
    beneficiary_name: '',
    beneficiary_address: '',
    beneficiary_state: '',
    beneficiary_zip: '',
    beneficiary_country: '',
    bank_name: '',
    bank_address: '',
    bank_state: '',
    bank_zip: '',
    bank_country: '',
    institution_number: '',
    branch_number: '',
    account_number: '',
    swift_code: '',
    voided_cheque: ''
  },
  fileUploadDirty: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_REFERRAL_BANK_DETAILS:
      return {
        ...state,
        referralBankDetails: action.payload,
        loading: false,
        formState: 'show'
        // editing: !state.editing
      };
    case SET_FORM_STATE:
      return {
        ...state,
        formState: action.formState
      };
    case SET_BANK_DETAILS_NEW:
      return {
        ...state,
        loading: false,
        formState: 'create'
      };
    case SET_FILE_UPLOAD_DIRTY:
      return {
        ...state,
        fileUploadDirty: action.fileUploadDirty
      };
    default:
      return state;
  }
};
